<svg width="308" height="122" viewBox="0 0 308 122" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path d="M17.9236 41.4538L15.7794 43.598L17.9236 45.7422L20.0678 43.598L17.9236 41.4538Z" fill="url(#paint0_linear_6151_1831)"/>
<path d="M33.0432 56.3466L30.6722 58.7176L33.0432 61.0886L35.4142 58.7176L33.0432 56.3466Z" fill="url(#paint1_linear_6151_1831)"/>
<path d="M48.1628 71.26L45.5856 73.8372L48.1628 76.4144L50.74 73.8372L48.1628 71.26Z" fill="url(#paint2_linear_6151_1831)"/>
<path d="M63.2824 86.5858L60.9114 88.9568L63.2824 91.3278L65.6534 88.9568L63.2824 86.5858Z" fill="url(#paint3_linear_6151_1831)"/>
<path d="M78.402 101.932L76.2578 104.076L78.402 106.221L80.5462 104.076L78.402 101.932Z" fill="url(#paint4_linear_6151_1831)"/>
<path d="M2.804 -4.338L0.226793 -1.7608L2.804 0.816406L5.3812 -1.7608L2.804 -4.338Z" fill="url(#paint5_linear_6151_1831)"/>
<path d="M17.9236 10.328L14.8928 13.3588L17.9236 16.3896L20.9544 13.3588L17.9236 10.328Z" fill="url(#paint6_linear_6151_1831)"/>
<path d="M33.0432 25.0146L29.5794 28.4784L33.0432 31.9421L36.507 28.4784L33.0432 25.0146Z" fill="url(#paint7_linear_6151_1831)"/>
<path d="M48.1628 39.7012L44.2661 43.598L48.1628 47.4947L52.0595 43.598L48.1628 39.7012Z" fill="url(#paint8_linear_6151_1831)"/>
<path d="M63.2824 54.3673L58.9321 58.7176L63.2824 63.0679L67.6327 58.7176L63.2824 54.3673Z" fill="url(#paint9_linear_6151_1831)"/>
<path d="M78.402 69.9405L74.5053 73.8372L78.402 77.7339L82.2987 73.8372L78.402 69.9405Z" fill="url(#paint10_linear_6151_1831)"/>
<path d="M93.5216 85.493L90.0578 88.9568L93.5216 92.4206L96.9854 88.9568L93.5216 85.493Z" fill="url(#paint11_linear_6151_1831)"/>
<path d="M108.641 101.046L105.61 104.076L108.641 107.107L111.672 104.076L108.641 101.046Z" fill="url(#paint12_linear_6151_1831)"/>
<path d="M123.761 116.619L121.184 119.196L123.761 121.773L126.338 119.196L123.761 116.619Z" fill="url(#paint13_linear_6151_1831)"/>
<path d="M2.804 -34.804L0 -32L2.804 -29.196L5.608 -32L2.804 -34.804Z" fill="url(#paint14_linear_6151_1831)"/>
<path d="M17.9236 -20.3442L14.4598 -16.8804L17.9236 -13.4166L21.3874 -16.8804L17.9236 -20.3442Z" fill="url(#paint15_linear_6151_1831)"/>
<path d="M33.0432 -5.88432L28.9197 -1.7608L33.0432 2.36272L37.1667 -1.7608L33.0432 -5.88432Z" fill="url(#paint16_linear_6151_1831)"/>
<path d="M48.1628 8.5755L43.3795 13.3588L48.1628 18.1421L52.9461 13.3588L48.1628 8.5755Z" fill="url(#paint17_linear_6151_1831)"/>
<path d="M63.2824 23.0354L57.8393 28.4784L63.2824 33.9214L68.7254 28.4784L63.2824 23.0354Z" fill="url(#paint18_linear_6151_1831)"/>
<path d="M78.402 37.4952L72.2992 43.598L78.402 49.7008L84.5048 43.598L78.402 37.4952Z" fill="url(#paint19_linear_6151_1831)"/>
<path d="M93.5216 53.2745L88.0785 58.7176L93.5216 64.1606L98.9646 58.7176L93.5216 53.2745Z" fill="url(#paint20_linear_6151_1831)"/>
<path d="M108.641 69.0539L103.858 73.8372L108.641 78.6205L113.424 73.8372L108.641 69.0539Z" fill="url(#paint21_linear_6151_1831)"/>
<path d="M123.761 84.8333L119.637 88.9568L123.761 93.0803L127.884 88.9568L123.761 84.8333Z" fill="url(#paint22_linear_6151_1831)"/>
<path d="M138.88 100.613L135.417 104.076L138.88 107.54L142.344 104.076L138.88 100.613Z" fill="url(#paint23_linear_6151_1831)"/>
<path d="M154 116.392L151.196 119.196L154 122L156.804 119.196L154 116.392Z" fill="url(#paint24_linear_6151_1831)"/>
<path d="M2.804 -64.8164L0.226793 -62.2392L2.804 -59.662L5.3812 -62.2392L2.804 -64.8164Z" fill="url(#paint25_linear_6151_1831)"/>
<path d="M17.9236 -50.5834L14.4598 -47.1196L17.9236 -43.6558L21.3874 -47.1196L17.9236 -50.5834Z" fill="url(#paint26_linear_6151_1831)"/>
<path d="M33.0432 -36.3503L28.6929 -32L33.0432 -27.6497L37.3935 -32L33.0432 -36.3503Z" fill="url(#paint27_linear_6151_1831)"/>
<path d="M48.1628 -22.0967L42.9465 -16.8804L48.1628 -11.6642L53.3791 -16.8804L48.1628 -22.0967Z" fill="url(#paint28_linear_6151_1831)"/>
<path d="M63.2824 -7.86363L57.1796 -1.7608L63.2824 4.342L69.3852 -1.7608L63.2824 -7.86363Z" fill="url(#paint29_linear_6151_1831)"/>
<path d="M78.402 6.36942L71.4126 13.3588L78.402 20.3482L85.3914 13.3588L78.402 6.36942Z" fill="url(#paint30_linear_6151_1831)"/>
<path d="M93.5216 20.6231L85.6663 28.4784L93.5216 36.3337L101.377 28.4784L93.5216 20.6231Z" fill="url(#paint31_linear_6151_1831)"/>
<path d="M108.641 36.6086L101.652 43.598L108.641 50.5874L115.631 43.598L108.641 36.6086Z" fill="url(#paint32_linear_6151_1831)"/>
<path d="M123.761 52.6148L117.658 58.7176L123.761 64.8204L129.864 58.7176L123.761 52.6148Z" fill="url(#paint33_linear_6151_1831)"/>
<path d="M138.88 68.6209L133.664 73.8372L138.88 79.0534L144.097 73.8372L138.88 68.6209Z" fill="url(#paint34_linear_6151_1831)"/>
<path d="M154 84.6065L149.65 88.9568L154 93.3071L158.35 88.9568L154 84.6065Z" fill="url(#paint35_linear_6151_1831)"/>
<path d="M169.12 100.613L165.656 104.076L169.12 107.54L172.583 104.076L169.12 100.613Z" fill="url(#paint36_linear_6151_1831)"/>
<path d="M184.239 116.619L181.662 119.196L184.239 121.773L186.816 119.196L184.239 116.619Z" fill="url(#paint37_linear_6151_1831)"/>
<path d="M17.9236 -80.3896L14.8928 -77.3588L17.9236 -74.328L20.9544 -77.3588L17.9236 -80.3896Z" fill="url(#paint38_linear_6151_1831)"/>
<path d="M33.0432 -66.3627L28.9197 -62.2392L33.0432 -58.1157L37.1667 -62.2392L33.0432 -66.3627Z" fill="url(#paint39_linear_6151_1831)"/>
<path d="M48.1628 -52.3359L42.9465 -47.1196L48.1628 -41.9033L53.3791 -47.1196L48.1628 -52.3359Z" fill="url(#paint40_linear_6151_1831)"/>
<path d="M63.2824 -38.3296L56.9528 -32L63.2824 -25.6704L69.612 -32L63.2824 -38.3296Z" fill="url(#paint41_linear_6151_1831)"/>
<path d="M78.402 -24.3028L70.9796 -16.8804L78.402 -9.45807L85.8243 -16.8804L78.402 -24.3028Z" fill="url(#paint42_linear_6151_1831)"/>
<path d="M93.5216 -10.2759L85.0065 -1.7608L93.5216 6.75427L102.037 -1.7608L93.5216 -10.2759Z" fill="url(#paint43_linear_6151_1831)"/>
<path d="M108.641 3.73036L99.0128 13.3588L108.641 22.9872L118.27 13.3588L108.641 3.73036Z" fill="url(#paint44_linear_6151_1831)"/>
<path d="M123.761 19.9633L115.246 28.4784L123.761 36.9935L132.276 28.4784L123.761 19.9633Z" fill="url(#paint45_linear_6151_1831)"/>
<path d="M138.88 36.1757L131.458 43.598L138.88 51.0203L146.303 43.598L138.88 36.1757Z" fill="url(#paint46_linear_6151_1831)"/>
<path d="M154 52.388L147.67 58.7176L154 65.0472L160.33 58.7176L154 52.388Z" fill="url(#paint47_linear_6151_1831)"/>
<path d="M169.12 68.6209L163.903 73.8372L169.12 79.0534L174.336 73.8372L169.12 68.6209Z" fill="url(#paint48_linear_6151_1831)"/>
<path d="M184.239 84.8333L180.116 88.9568L184.239 93.0803L188.363 88.9568L184.239 84.8333Z" fill="url(#paint49_linear_6151_1831)"/>
<path d="M199.359 101.046L196.328 104.076L199.359 107.107L202.39 104.076L199.359 101.046Z" fill="url(#paint50_linear_6151_1831)"/>
<path d="M17.9236 -109.742L15.7794 -107.598L17.9236 -105.454L20.0678 -107.598L17.9236 -109.742Z" fill="url(#paint51_linear_6151_1831)"/>
<path d="M33.0432 -95.9422L29.5794 -92.4784L33.0432 -89.0146L36.507 -92.4784L33.0432 -95.9422Z" fill="url(#paint52_linear_6151_1831)"/>
<path d="M48.1628 -82.1421L43.3795 -77.3588L48.1628 -72.5755L52.9461 -77.3588L48.1628 -82.1421Z" fill="url(#paint53_linear_6151_1831)"/>
<path d="M63.2824 -68.342L57.1796 -62.2392L63.2824 -56.1364L69.3852 -62.2392L63.2824 -68.342Z" fill="url(#paint54_linear_6151_1831)"/>
<path d="M78.402 -54.5419L70.9796 -47.1196L78.402 -39.6973L85.8243 -47.1196L78.402 -54.5419Z" fill="url(#paint55_linear_6151_1831)"/>
<path d="M93.5216 -40.7419L84.7797 -32L93.5216 -23.2581L102.263 -32L93.5216 -40.7419Z" fill="url(#paint56_linear_6151_1831)"/>
<path d="M108.641 -26.9418L98.5798 -16.8804L108.641 -6.819L118.703 -16.8804L108.641 -26.9418Z" fill="url(#paint57_linear_6151_1831)"/>
<path d="M123.761 -13.1417L112.38 -1.7608L123.761 9.62012L135.142 -1.7608L123.761 -13.1417Z" fill="url(#paint58_linear_6151_1831)"/>
<path d="M138.88 3.29739L128.819 13.3588L138.88 23.4202L148.942 13.3588L138.88 3.29739Z" fill="url(#paint59_linear_6151_1831)"/>
<path d="M154 19.7365L145.258 28.4784L154 37.2203L162.742 28.4784L154 19.7365Z" fill="url(#paint60_linear_6151_1831)"/>
<path d="M169.12 36.1756L161.697 43.598L169.12 51.0204L176.542 43.598L169.12 36.1756Z" fill="url(#paint61_linear_6151_1831)"/>
<path d="M184.239 52.6148L178.136 58.7176L184.239 64.8204L190.342 58.7176L184.239 52.6148Z" fill="url(#paint62_linear_6151_1831)"/>
<path d="M199.359 69.0539L194.576 73.8372L199.359 78.6205L204.142 73.8372L199.359 69.0539Z" fill="url(#paint63_linear_6151_1831)"/>
<path d="M214.478 85.493L211.015 88.9568L214.478 92.4206L217.942 88.9568L214.478 85.493Z" fill="url(#paint64_linear_6151_1831)"/>
<path d="M229.598 101.932L227.454 104.076L229.598 106.221L231.742 104.076L229.598 101.932Z" fill="url(#paint65_linear_6151_1831)"/>
<path d="M33.0432 -125.089L30.6722 -122.718L33.0432 -120.347L35.4142 -122.718L33.0432 -125.089Z" fill="url(#paint66_linear_6151_1831)"/>
<path d="M48.1628 -111.495L44.2661 -107.598L48.1628 -103.701L52.0595 -107.598L48.1628 -111.495Z" fill="url(#paint67_linear_6151_1831)"/>
<path d="M63.2824 -97.9215L57.8393 -92.4784L63.2824 -87.0353L68.7254 -92.4784L63.2824 -97.9215Z" fill="url(#paint68_linear_6151_1831)"/>
<path d="M78.402 -84.3482L71.4126 -77.3588L78.402 -70.3694L85.3914 -77.3588L78.402 -84.3482Z" fill="url(#paint69_linear_6151_1831)"/>
<path d="M93.5216 -70.7543L85.0065 -62.2392L93.5216 -53.7241L102.037 -62.2392L93.5216 -70.7543Z" fill="url(#paint70_linear_6151_1831)"/>
<path d="M108.641 -57.181L98.5798 -47.1196L108.641 -37.0582L118.703 -47.1196L108.641 -57.181Z" fill="url(#paint71_linear_6151_1831)"/>
<path d="M123.761 -43.6077L112.153 -32L123.761 -20.3923L135.369 -32L123.761 -43.6077Z" fill="url(#paint72_linear_6151_1831)"/>
<path d="M138.88 -30.0138L125.747 -16.8804L138.88 -3.74698L152.014 -16.8804L138.88 -30.0138Z" fill="url(#paint73_linear_6151_1831)"/>
<path d="M154 -13.3685L142.392 -1.7608L154 9.84692L165.608 -1.7608L154 -13.3685Z" fill="url(#paint74_linear_6151_1831)"/>
<path d="M169.12 3.29739L159.058 13.3588L169.12 23.4202L179.181 13.3588L169.12 3.29739Z" fill="url(#paint75_linear_6151_1831)"/>
<path d="M184.239 19.9633L175.724 28.4784L184.239 36.9935L192.754 28.4784L184.239 19.9633Z" fill="url(#paint76_linear_6151_1831)"/>
<path d="M199.359 36.6086L192.369 43.598L199.359 50.5874L206.348 43.598L199.359 36.6086Z" fill="url(#paint77_linear_6151_1831)"/>
<path d="M214.478 53.2745L209.035 58.7176L214.478 64.1607L219.921 58.7176L214.478 53.2745Z" fill="url(#paint78_linear_6151_1831)"/>
<path d="M229.598 69.9405L225.701 73.8372L229.598 77.7339L233.495 73.8372L229.598 69.9405Z" fill="url(#paint79_linear_6151_1831)"/>
<path d="M244.718 86.5858L242.347 88.9568L244.718 91.3278L247.089 88.9568L244.718 86.5858Z" fill="url(#paint80_linear_6151_1831)"/>
<path d="M48.1628 -140.414L45.5856 -137.837L48.1628 -135.26L50.74 -137.837L48.1628 -140.414Z" fill="url(#paint81_linear_6151_1831)"/>
<path d="M63.2824 -127.068L58.9321 -122.718L63.2824 -118.367L67.6327 -122.718L63.2824 -127.068Z" fill="url(#paint82_linear_6151_1831)"/>
<path d="M78.402 -113.701L72.2992 -107.598L78.402 -101.495L84.5048 -107.598L78.402 -113.701Z" fill="url(#paint83_linear_6151_1831)"/>
<path d="M93.5216 -100.334L85.6663 -92.4784L93.5216 -84.6231L101.377 -92.4784L93.5216 -100.334Z" fill="url(#paint84_linear_6151_1831)"/>
<path d="M108.641 -86.9872L99.0128 -77.3588L108.641 -67.7304L118.27 -77.3588L108.641 -86.9872Z" fill="url(#paint85_linear_6151_1831)"/>
<path d="M123.761 -73.6201L112.38 -62.2392L123.761 -50.8583L135.142 -62.2392L123.761 -73.6201Z" fill="url(#paint86_linear_6151_1831)"/>
<path d="M138.88 -60.253L125.747 -47.1196L138.88 -33.9862L152.014 -47.1196L138.88 -60.253Z" fill="url(#paint87_linear_6151_1831)"/>
<path d="M154 -46.9066L139.093 -32L154 -17.0934L168.907 -32L154 -46.9066Z" fill="url(#paint88_linear_6151_1831)"/>
<path d="M169.12 -30.0138L155.986 -16.8804L169.12 -3.74698L182.253 -16.8804L169.12 -30.0138Z" fill="url(#paint89_linear_6151_1831)"/>
<path d="M184.239 -13.1417L172.858 -1.7608L184.239 9.62012L195.62 -1.7608L184.239 -13.1417Z" fill="url(#paint90_linear_6151_1831)"/>
<path d="M199.359 3.73038L189.73 13.3588L199.359 22.9872L208.987 13.3588L199.359 3.73038Z" fill="url(#paint91_linear_6151_1831)"/>
<path d="M214.478 20.6231L206.623 28.4784L214.478 36.3337L222.334 28.4784L214.478 20.6231Z" fill="url(#paint92_linear_6151_1831)"/>
<path d="M229.598 37.4952L223.495 43.598L229.598 49.7008L235.701 43.598L229.598 37.4952Z" fill="url(#paint93_linear_6151_1831)"/>
<path d="M244.718 54.3673L240.367 58.7176L244.718 63.0679L249.068 58.7176L244.718 54.3673Z" fill="url(#paint94_linear_6151_1831)"/>
<path d="M259.837 71.26L257.26 73.8372L259.837 76.4144L262.414 73.8372L259.837 71.26Z" fill="url(#paint95_linear_6151_1831)"/>
<path d="M63.2824 -155.328L60.9114 -152.957L63.2824 -150.586L65.6534 -152.957L63.2824 -155.328Z" fill="url(#paint96_linear_6151_1831)"/>
<path d="M78.402 -141.734L74.5053 -137.837L78.402 -133.94L82.2987 -137.837L78.402 -141.734Z" fill="url(#paint97_linear_6151_1831)"/>
<path d="M93.5216 -128.161L88.0785 -122.718L93.5216 -117.275L98.9646 -122.718L93.5216 -128.161Z" fill="url(#paint98_linear_6151_1831)"/>
<path d="M108.641 -114.587L101.652 -107.598L108.641 -100.609L115.631 -107.598L108.641 -114.587Z" fill="url(#paint99_linear_6151_1831)"/>
<path d="M123.761 -100.993L115.246 -92.4784L123.761 -83.9633L132.276 -92.4784L123.761 -100.993Z" fill="url(#paint100_linear_6151_1831)"/>
<path d="M138.88 -87.4202L128.819 -77.3588L138.88 -67.2974L148.942 -77.3588L138.88 -87.4202Z" fill="url(#paint101_linear_6151_1831)"/>
<path d="M154 -73.8469L142.392 -62.2392L154 -50.6315L165.608 -62.2392L154 -73.8469Z" fill="url(#paint102_linear_6151_1831)"/>
<path d="M169.12 -60.253L155.986 -47.1196L169.12 -33.9862L182.253 -47.1196L169.12 -60.253Z" fill="url(#paint103_linear_6151_1831)"/>
<path d="M184.239 -43.6077L172.631 -32L184.239 -20.3923L195.847 -32L184.239 -43.6077Z" fill="url(#paint104_linear_6151_1831)"/>
<path d="M199.359 -26.9418L189.297 -16.8804L199.359 -6.81898L209.42 -16.8804L199.359 -26.9418Z" fill="url(#paint105_linear_6151_1831)"/>
<path d="M214.478 -10.2759L205.963 -1.7608L214.478 6.7543L222.993 -1.76079L214.478 -10.2759Z" fill="url(#paint106_linear_6151_1831)"/>
<path d="M229.598 6.36942L222.609 13.3588L229.598 20.3482L236.587 13.3588L229.598 6.36942Z" fill="url(#paint107_linear_6151_1831)"/>
<path d="M244.718 23.0354L239.275 28.4784L244.718 33.9214L250.161 28.4784L244.718 23.0354Z" fill="url(#paint108_linear_6151_1831)"/>
<path d="M259.837 39.7013L255.94 43.598L259.837 47.4947L263.734 43.598L259.837 39.7013Z" fill="url(#paint109_linear_6151_1831)"/>
<path d="M274.957 56.3466L272.586 58.7176L274.957 61.0886L277.328 58.7176L274.957 56.3466Z" fill="url(#paint110_linear_6151_1831)"/>
<path d="M78.402 -170.221L76.2578 -168.076L78.402 -165.932L80.5462 -168.076L78.402 -170.221Z" fill="url(#paint111_linear_6151_1831)"/>
<path d="M93.5216 -156.421L90.0578 -152.957L93.5216 -149.493L96.9854 -152.957L93.5216 -156.421Z" fill="url(#paint112_linear_6151_1831)"/>
<path d="M108.641 -142.621L103.858 -137.837L108.641 -133.054L113.424 -137.837L108.641 -142.621Z" fill="url(#paint113_linear_6151_1831)"/>
<path d="M123.761 -128.82L117.658 -122.718L123.761 -116.615L129.864 -122.718L123.761 -128.82Z" fill="url(#paint114_linear_6151_1831)"/>
<path d="M138.88 -115.02L131.458 -107.598L138.88 -100.176L146.303 -107.598L138.88 -115.02Z" fill="url(#paint115_linear_6151_1831)"/>
<path d="M154 -101.22L145.258 -92.4784L154 -83.7365L162.742 -92.4784L154 -101.22Z" fill="url(#paint116_linear_6151_1831)"/>
<path d="M169.12 -87.4202L159.058 -77.3588L169.12 -67.2974L179.181 -77.3588L169.12 -87.4202Z" fill="url(#paint117_linear_6151_1831)"/>
<path d="M184.239 -73.6201L172.858 -62.2392L184.239 -50.8583L195.62 -62.2392L184.239 -73.6201Z" fill="url(#paint118_linear_6151_1831)"/>
<path d="M199.359 -57.181L189.297 -47.1196L199.359 -37.0582L209.42 -47.1196L199.359 -57.181Z" fill="url(#paint119_linear_6151_1831)"/>
<path d="M214.478 -40.7419L205.737 -32L214.478 -23.2581L223.22 -32L214.478 -40.7419Z" fill="url(#paint120_linear_6151_1831)"/>
<path d="M229.598 -24.3028L222.176 -16.8804L229.598 -9.45805L237.02 -16.8804L229.598 -24.3028Z" fill="url(#paint121_linear_6151_1831)"/>
<path d="M244.718 -7.86363L238.615 -1.7608L244.718 4.342L250.82 -1.7608L244.718 -7.86363Z" fill="url(#paint122_linear_6151_1831)"/>
<path d="M259.837 8.5755L255.054 13.3588L259.837 18.1421L264.62 13.3588L259.837 8.5755Z" fill="url(#paint123_linear_6151_1831)"/>
<path d="M274.957 25.0146L271.493 28.4784L274.957 31.9421L278.421 28.4784L274.957 25.0146Z" fill="url(#paint124_linear_6151_1831)"/>
<path d="M290.076 41.4538L287.932 43.598L290.076 45.7422L292.221 43.598L290.076 41.4538Z" fill="url(#paint125_linear_6151_1831)"/>
<path d="M108.641 -171.107L105.61 -168.076L108.641 -165.046L111.672 -168.076L108.641 -171.107Z" fill="url(#paint126_linear_6151_1831)"/>
<path d="M123.761 -157.08L119.637 -152.957L123.761 -148.833L127.884 -152.957L123.761 -157.08Z" fill="url(#paint127_linear_6151_1831)"/>
<path d="M138.88 -143.053L133.664 -137.837L138.88 -132.621L144.097 -137.837L138.88 -143.053Z" fill="url(#paint128_linear_6151_1831)"/>
<path d="M154 -129.047L147.67 -122.718L154 -116.388L160.33 -122.718L154 -129.047Z" fill="url(#paint129_linear_6151_1831)"/>
<path d="M169.12 -115.02L161.697 -107.598L169.12 -100.176L176.542 -107.598L169.12 -115.02Z" fill="url(#paint130_linear_6151_1831)"/>
<path d="M184.239 -100.993L175.724 -92.4784L184.239 -83.9633L192.754 -92.4784L184.239 -100.993Z" fill="url(#paint131_linear_6151_1831)"/>
<path d="M199.359 -86.9872L189.73 -77.3588L199.359 -67.7304L208.987 -77.3588L199.359 -86.9872Z" fill="url(#paint132_linear_6151_1831)"/>
<path d="M214.478 -70.7543L205.963 -62.2392L214.478 -53.7241L222.993 -62.2392L214.478 -70.7543Z" fill="url(#paint133_linear_6151_1831)"/>
<path d="M229.598 -54.5419L222.176 -47.1196L229.598 -39.6973L237.02 -47.1196L229.598 -54.5419Z" fill="url(#paint134_linear_6151_1831)"/>
<path d="M244.718 -38.3296L238.388 -32L244.718 -25.6704L251.047 -32L244.718 -38.3296Z" fill="url(#paint135_linear_6151_1831)"/>
<path d="M259.837 -22.0966L254.621 -16.8804L259.837 -11.6642L265.053 -16.8804L259.837 -22.0966Z" fill="url(#paint136_linear_6151_1831)"/>
<path d="M274.957 -5.88434L270.833 -1.7608L274.957 2.36272L279.08 -1.7608L274.957 -5.88434Z" fill="url(#paint137_linear_6151_1831)"/>
<path d="M290.076 10.328L287.046 13.3588L290.076 16.3896L293.107 13.3588L290.076 10.328Z" fill="url(#paint138_linear_6151_1831)"/>
<path d="M123.761 -185.773L121.184 -183.196L123.761 -180.619L126.338 -183.196L123.761 -185.773Z" fill="url(#paint139_linear_6151_1831)"/>
<path d="M138.88 -171.54L135.417 -168.076L138.88 -164.613L142.344 -168.076L138.88 -171.54Z" fill="url(#paint140_linear_6151_1831)"/>
<path d="M154 -157.307L149.65 -152.957L154 -148.606L158.35 -152.957L154 -157.307Z" fill="url(#paint141_linear_6151_1831)"/>
<path d="M169.12 -143.053L163.903 -137.837L169.12 -132.621L174.336 -137.837L169.12 -143.053Z" fill="url(#paint142_linear_6151_1831)"/>
<path d="M184.239 -128.82L178.136 -122.718L184.239 -116.615L190.342 -122.718L184.239 -128.82Z" fill="url(#paint143_linear_6151_1831)"/>
<path d="M199.359 -114.587L192.369 -107.598L199.359 -100.609L206.348 -107.598L199.359 -114.587Z" fill="url(#paint144_linear_6151_1831)"/>
<path d="M214.478 -100.334L206.623 -92.4784L214.478 -84.6231L222.334 -92.4784L214.478 -100.334Z" fill="url(#paint145_linear_6151_1831)"/>
<path d="M229.598 -84.3482L222.609 -77.3588L229.598 -70.3694L236.587 -77.3588L229.598 -84.3482Z" fill="url(#paint146_linear_6151_1831)"/>
<path d="M244.718 -68.342L238.615 -62.2392L244.718 -56.1364L250.82 -62.2392L244.718 -68.342Z" fill="url(#paint147_linear_6151_1831)"/>
<path d="M259.837 -52.3359L254.621 -47.1196L259.837 -41.9034L265.053 -47.1196L259.837 -52.3359Z" fill="url(#paint148_linear_6151_1831)"/>
<path d="M274.957 -36.3503L270.607 -32L274.957 -27.6497L279.307 -32L274.957 -36.3503Z" fill="url(#paint149_linear_6151_1831)"/>
<path d="M290.076 -20.3442L286.613 -16.8804L290.076 -13.4166L293.54 -16.8804L290.076 -20.3442Z" fill="url(#paint150_linear_6151_1831)"/>
<path d="M305.196 -4.33801L302.619 -1.7608L305.196 0.816391L307.773 -1.7608L305.196 -4.33801Z" fill="url(#paint151_linear_6151_1831)"/>
<path d="M154 -186L151.196 -183.196L154 -180.392L156.804 -183.196L154 -186Z" fill="url(#paint152_linear_6151_1831)"/>
<path d="M169.12 -171.54L165.656 -168.076L169.12 -164.613L172.583 -168.076L169.12 -171.54Z" fill="url(#paint153_linear_6151_1831)"/>
<path d="M184.239 -157.08L180.116 -152.957L184.239 -148.833L188.363 -152.957L184.239 -157.08Z" fill="url(#paint154_linear_6151_1831)"/>
<path d="M199.359 -142.621L194.576 -137.837L199.359 -133.054L204.142 -137.837L199.359 -142.621Z" fill="url(#paint155_linear_6151_1831)"/>
<path d="M214.478 -128.161L209.035 -122.718L214.478 -117.275L219.921 -122.718L214.478 -128.161Z" fill="url(#paint156_linear_6151_1831)"/>
<path d="M229.598 -113.701L223.495 -107.598L229.598 -101.495L235.701 -107.598L229.598 -113.701Z" fill="url(#paint157_linear_6151_1831)"/>
<path d="M244.718 -97.9215L239.275 -92.4784L244.718 -87.0354L250.161 -92.4784L244.718 -97.9215Z" fill="url(#paint158_linear_6151_1831)"/>
<path d="M259.837 -82.1421L255.054 -77.3588L259.837 -72.5755L264.62 -77.3588L259.837 -82.1421Z" fill="url(#paint159_linear_6151_1831)"/>
<path d="M274.957 -66.3627L270.833 -62.2392L274.957 -58.1157L279.08 -62.2392L274.957 -66.3627Z" fill="url(#paint160_linear_6151_1831)"/>
<path d="M290.076 -50.5834L286.613 -47.1196L290.076 -43.6559L293.54 -47.1196L290.076 -50.5834Z" fill="url(#paint161_linear_6151_1831)"/>
<path d="M305.196 -34.804L302.392 -32L305.196 -29.196L308 -32L305.196 -34.804Z" fill="url(#paint162_linear_6151_1831)"/>
<path d="M184.239 -185.773L181.662 -183.196L184.239 -180.619L186.816 -183.196L184.239 -185.773Z" fill="url(#paint163_linear_6151_1831)"/>
<path d="M199.359 -171.107L196.328 -168.076L199.359 -165.046L202.39 -168.076L199.359 -171.107Z" fill="url(#paint164_linear_6151_1831)"/>
<path d="M214.478 -156.421L211.015 -152.957L214.478 -149.493L217.942 -152.957L214.478 -156.421Z" fill="url(#paint165_linear_6151_1831)"/>
<path d="M229.598 -141.734L225.701 -137.837L229.598 -133.94L233.495 -137.837L229.598 -141.734Z" fill="url(#paint166_linear_6151_1831)"/>
<path d="M244.718 -127.068L240.367 -122.718L244.718 -118.367L249.068 -122.718L244.718 -127.068Z" fill="url(#paint167_linear_6151_1831)"/>
<path d="M259.837 -111.495L255.94 -107.598L259.837 -103.701L263.734 -107.598L259.837 -111.495Z" fill="url(#paint168_linear_6151_1831)"/>
<path d="M274.957 -95.9422L271.493 -92.4784L274.957 -89.0146L278.421 -92.4784L274.957 -95.9422Z" fill="url(#paint169_linear_6151_1831)"/>
<path d="M290.076 -80.3896L287.046 -77.3588L290.076 -74.328L293.107 -77.3588L290.076 -80.3896Z" fill="url(#paint170_linear_6151_1831)"/>
<path d="M305.196 -64.8164L302.619 -62.2392L305.196 -59.662L307.773 -62.2392L305.196 -64.8164Z" fill="url(#paint171_linear_6151_1831)"/>
<path d="M229.598 -170.221L227.454 -168.076L229.598 -165.932L231.742 -168.076L229.598 -170.221Z" fill="url(#paint172_linear_6151_1831)"/>
<path d="M244.718 -155.328L242.347 -152.957L244.718 -150.586L247.089 -152.957L244.718 -155.328Z" fill="url(#paint173_linear_6151_1831)"/>
<path d="M259.837 -140.414L257.26 -137.837L259.837 -135.26L262.414 -137.837L259.837 -140.414Z" fill="url(#paint174_linear_6151_1831)"/>
<path d="M274.957 -125.089L272.586 -122.718L274.957 -120.347L277.328 -122.718L274.957 -125.089Z" fill="url(#paint175_linear_6151_1831)"/>
<path d="M290.076 -109.742L287.932 -107.598L290.076 -105.454L292.221 -107.598L290.076 -109.742Z" fill="url(#paint176_linear_6151_1831)"/>
</g>
<defs>
<linearGradient id="paint0_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint1_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint2_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint3_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint4_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint5_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint6_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint7_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint8_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint9_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint10_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint11_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint12_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint13_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint14_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint15_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint16_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint17_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint18_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint19_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint20_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint21_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint22_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint23_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint24_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint25_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint26_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint27_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint28_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint29_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint30_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint31_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint32_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint33_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint34_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint35_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint36_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint37_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint38_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint39_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint40_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint41_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint42_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint43_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint44_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint45_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint46_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint47_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint48_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint49_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint50_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint51_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint52_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint53_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint54_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint55_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint56_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint57_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint58_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint59_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint60_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint61_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint62_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint63_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint64_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint65_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint66_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint67_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint68_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint69_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint70_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint71_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint72_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint73_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint74_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint75_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint76_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint77_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint78_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint79_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint80_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint81_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint82_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint83_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint84_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint85_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint86_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint87_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint88_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint89_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint90_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint91_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint92_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint93_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint94_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint95_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint96_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint97_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint98_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint99_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint100_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint101_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint102_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint103_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint104_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint105_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint106_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint107_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint108_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint109_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint110_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint111_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint112_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint113_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint114_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint115_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint116_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint117_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint118_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint119_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint120_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint121_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint122_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint123_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint124_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint125_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint126_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint127_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint128_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint129_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint130_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint131_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint132_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint133_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint134_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint135_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint136_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint137_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint138_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint139_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint140_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint141_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint142_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint143_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint144_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint145_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint146_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint147_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint148_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint149_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint150_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint151_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint152_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint153_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint154_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint155_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint156_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint157_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint158_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint159_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint160_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint161_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint162_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint163_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint164_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint165_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint166_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint167_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint168_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint169_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint170_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint171_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint172_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint173_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint174_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint175_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint176_linear_6151_1831" x1="154" y1="29.2652" x2="154" y2="122" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF3ED4"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
</defs>
</svg>
